import { render, staticRenderFns } from "./OverView.vue?vue&type=template&id=0bdd3950&scoped=true&"
import script from "./OverView.vue?vue&type=script&lang=js&"
export * from "./OverView.vue?vue&type=script&lang=js&"
import style0 from "./OverView.vue?vue&type=style&index=0&id=0bdd3950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdd3950",
  null
  
)

component.options.__file = "OverView.vue"
export default component.exports